import { formatNumber } from "@/apps/credit-line/helpers/formatNumber.helper";

export default function currencyFormat(
  amount: number | string,
  fractionDigits?: number
): string {
  return `$${formatNumber(
    typeof amount === "number" ? amount : Number(amount),
    fractionDigits
  )}`;
}
